module.exports = __webpack_public_path__ + "media/images/fut-desktop-50ccfe025b41bbe2a6c5768bb19e6d4b.jpg";